import { render, staticRenderFns } from "./FVCDraft.vue?vue&type=template&id=232b098e&"
import script from "./FVCDraft.vue?vue&type=script&lang=js&"
export * from "./FVCDraft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports